import React from 'react';
import styled from 'styled-components';
import appInfoContainer from '../../../auth/appInfoContainer'

export default function GroupImagesFit({groupInfo}) {
    // 두개의 날짜를 비교하여 차이를 알려준다.
    function dateDiff(_date1, _date2) {
        let diffDate_1 = _date1 instanceof Date ? _date1 :new Date(_date1);
        let diffDate_2 = _date2 instanceof Date ? _date2 :new Date(_date2);

        diffDate_1 =new Date(diffDate_1.getFullYear(), diffDate_1.getMonth()+1, diffDate_1.getDate());
        diffDate_2 =new Date(diffDate_2.getFullYear(), diffDate_2.getMonth()+1, diffDate_2.getDate());

        let diff = Math.abs(diffDate_2.getTime() - diffDate_1.getTime());
        diff = Math.ceil(diff / (1000 * 3600 * 24));

        return diff;
    }
    let start_date =  groupInfo.start_date;

    let imgTag = [];
    if(groupInfo.group_cover_img !== undefined)
    {
        imgTag.push(<GroupCoverImg  key="group-cover-img"  src={appInfoContainer.imagePath +"/group_cover_img/"+groupInfo.group_cover_img} />);
    }

    return(
       <ImagesInner>
           <Images>{imgTag}</Images>
           {
             new Date(start_date).getTime() > new Date().getTime()
             ?
            <DDay>D-{dateDiff(start_date,new Date())}</DDay>
            :
            null
           }
       </ImagesInner>
    );
}




const ImagesInner = styled.div`
    position: relative;
`
const Images = styled.div`
    width: 100%;
    height: calc(100vw*(240/375));
`
const GroupCoverImg = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`
const DDay = styled.span`
    position: absolute;
    top: calc(100vw*(9.5/375));
    right: calc(100vw*(17/375));
    height: calc(100vw*(23/375));
    border-radius: calc(100vw*(13/375));
    background-color: #121212;
    font-size: calc(100vw*(14/375));
    font-weight: 500;
    line-height: calc(100vw*(23/375));
    letter-spacing: 0.28px;
    text-align: center;
    color: #ffffff;
    padding: 0 calc(100vw*(13/375)) 0 calc(100vw*(14/375));
`